import React from 'react'

export default () => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.18762 6L0.666626 10.3105L1.73946 11.3333L7.33329 6L1.73946 0.666666L0.666626 1.68954L5.18762 6Z" fill="#003A80"/>
  </svg>
)
